// extracted by mini-css-extract-plugin
export default {"warning":"MyRegistersTableArea_warning__GZcmx","danger":"MyRegistersTableArea_danger__p1Owr"};